module.exports = __webpack_public_path__ + "img/kiosk_short.b3811266.png";